<template>
  <a-modal
    :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="handleSubmit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <a-form-model
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="类型" prop="productType">
        <a-select
          v-model="form.productType"
          placeholder="请选择类型"
          @change="handleTypeChange"
          :disabled="disabeld"
        >
          <a-select-option
            v-for="item in productTypeList"
            :key="item.value"
            :value="item.text"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <template v-if="isCulturalMaterial">
        <a-form-model-item label="类别" prop="resourceCategory">
          <a-select
            v-model="form.resourceCategory"
            placeholder="请选择类别"
            :disabled="disabeld"
          >
            <a-select-option
              v-for="item in resourceCategoryList"
              :key="item.value"
              :value="item.text"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="数量" prop="resourceNum">
          <a-input-number
            v-model="form.resourceNum"
            :min="1"
            :precision="0"
            style="width: 100%"
            placeholder="请输入数量"
            :disabled="disabeld"
          />
        </a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item label="名称" prop="resourceCategory">
          <a-input
            v-model="form.resourceCategory"
            placeholder="请输入名称"
            :disabled="disabeld"
          />
        </a-form-model-item>
      </template>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";

// 常量定义
const CULTURAL_MATERIAL = "文化素材类的数字资源建设数量";
const DICT_CODES = {
  PRODUCT_TYPE: "Ideological_political_education_product",
  RESOURCE_CATEGORY: "resource_category",
};

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },

      form: {
        id: "",
        applyId: "",
        productType: "",
        resourceCategory: "",
        resourceNum: null,
      },

      rules: {
        productType: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        resourceCategory: [
          { required: true, message: "请输入名称或选择类别", trigger: "blur" },
        ],
        resourceNum: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.isCulturalMaterial && !value) {
                callback(new Error("请输入数量"));
              } else {
                callback();
              }
            },
          },
        ],
      },

      applyType: 2,
      mode: "", // 'add' or 'edit'
      title: "",

      // 字典数据
      productTypeList: [],
      resourceCategoryList: [],
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },

  computed: {
    isCulturalMaterial() {
      return this.form.productType === CULTURAL_MATERIAL;
    },
  },

  methods: {
    // 初始化模态框
    init(mode, record, taskId, detailId) {
      this.mode = mode;
      this.visible = true;
      this.resetForm();
      this.loadDictData();

      if (mode === "add") {
        this.title = "新增思政育人";
        this.form.applyId = record.id;
      } else if (mode == "edit") {
        this.title = "编辑思政育人";
        this.form = {
          ...this.form,
          id: record.id,
          applyId: record.applyId,
          productType: record.productType,
          resourceCategory: record.resourceCategory,
          resourceNum: record.resourceNum,
        };
        this.teacherdata = record;
      } else if (mode === "audit-edit") {
        this.title = "编辑思政育人";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          ...this.form,
          id: record.id,
          applyId: record.applyId,
          productType: record.productType,
          resourceCategory: record.resourceCategory,
          resourceNum: record.resourceNum,
        };
      } else {
        this.disabeld = true;
        this.title = "查看思政育人";
        this.saveText = "关闭";
        this.form = {
          ...this.form,
          id: record.id,
          applyId: record.applyId,
          productType: record.productType,
          resourceCategory: record.resourceCategory,
          resourceNum: record.resourceNum,
        };
      }
    },

    // 加载字典数据
    async loadDictData() {
      try {
        const [productRes, categoryRes] = await Promise.all([
          getAction(
            `/baseCommon/getDictItemsByCode?code=${DICT_CODES.PRODUCT_TYPE}`
          ),
          getAction(
            `/baseCommon/getDictItemsByCode?code=${DICT_CODES.RESOURCE_CATEGORY}`
          ),
        ]);

        if (productRes.code === 200) this.productTypeList = productRes.result;
        if (categoryRes.code === 200)
          this.resourceCategoryList = categoryRes.result;
      } catch (error) {
        console.error("加载字典数据失败:", error);
      }
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        applyId: "",
        productType: "",
        resourceCategory: "",
        resourceNum: null,
      };
      this.$refs.formRef?.clearValidate();
    },

    // 处理类型变化
    handleTypeChange() {
      this.form.resourceCategory = "";
      this.form.resourceNum = null;
    },

    // 提交表单
    async handleSubmit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        const params = {
          ...this.form,
          applyType: this.applyType,
        };

        let apiUrl =
          this.mode === "add"
            ? "/lxbase/lxIdeologicalPoliticalEducation/add"
            : this.mode === "edit"
            ? "/lxbase/lxIdeologicalPoliticalEducation/edit"
            : "/audit/lxAuditTask/reSubmitTask";
        if (
          this.teacherdata?.status == "0" ||
          this.teacherdata?.status == "1" ||
          this.teacherdata?.status == "4" ||
          this.teacherdata?.status == "3" ||
          (this.teacherdata?.status == "2" && this.teacherdata?.operation)
        ) {
          apiUrl = "/audit/lxAuditTask/editTaskAndDetail";
        }
        const action = this.mode === "edit" ? putAction : postAction;
        const auditParams = {
          taskId: this.taskId,
          afterJson: JSON.stringify({ ...this.form }),
          detailId: this.detailId,
        };
        let auditParams1 = {
          id: this.teacherdata?.taskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        };
        if (this.teacherdata?.status == "4") {
          auditParams1.auditState = "1";
        }
        let res = "";
        if (
          this.teacherdata?.status == "0" ||
          this.teacherdata?.status == "1" ||
          this.teacherdata?.status == "4" ||
          this.teacherdata?.status == "3" ||
          (this.teacherdata?.status == "2" && this.teacherdata?.operation)
        ) {
          res = await action(apiUrl, auditParams1);
        } else {
          res = await action(
            apiUrl,
            this.mode === "audit-edit" ? auditParams : params
          );
        }

        if (res.code === 200) {
          this.$message.success(res.message || `${this.title}成功`);
          this.visible = false;
          this.$emit("addEducatingPeople");
        } else {
          this.$message.error(res.message || `${this.title}失败`);
        }
      } catch (error) {
        if (error.errorFields) {
          this.$message.warning("请完善表单信息");
        } else {
          console.error("提交失败:", error);
        }
      } finally {
        this.confirmLoading = false;
      }
    },

    // 取消
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>